import styled from 'styled-components';

export const Container = styled.div`
  .card-header {
    background-color: transparent;
  }
`;